<template>
  <div class="tabs_content" id="tab-2">
    <section>
      <div class="status">
        <a
            v-if="isEditable"
            @click.stop="_createNewBootConfig"
            :title="$gettext('Přidat konfiguraci bootování')"
            class="add add_expand"
            v-translate>Přidat konfiguraci bootování</a>
        <h2 v-translate>Přiřazené konfigurace bootování</h2>
      </div>

      <div class="vypis vypis_detail table_overflow">
        <table class="vypis vypis_detail">
          <thead>

          <tr>
            <th class="no_padding drag_drop"></th>

            <th><span v-translate>Název</span></th>
            <th><span v-translate>Verze image</span></th>
            <th><span v-translate>Verze splash</span></th>
            <th><span v-translate>Operátor</span></th>
            <th><span v-translate>Zařízení</span></th>

            <th class="no_padding edit" />
          </tr>

          </thead>

          <tbody>
          <device-detail-boot-config-row
              v-for="config in assignedConfigs"
              :entity="config"
              :device="entity"
              :key="config.id"
              :ref="'assigned-config-row-ref-'+config.id"
              @reload="_initBootConfig"
          ></device-detail-boot-config-row>

          <tr v-if="assignedConfigs.length === 0">
            <td colspan="9">{{ $gettext('Nebyly nalezeny žádné přiřazené konfigurace.') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section>
      <div class="status">
        <h2 v-translate>Dostupné konfigurace bootování</h2>
      </div>

      <div class="vypis vypis_detail table_overflow">
        <table class="vypis vypis_detail">
          <thead>

          <tr>
            <th class="no_padding drag_drop"></th>

            <th><span v-translate>Název</span></th>
            <th><span v-translate>Verze image</span></th>
            <th><span v-translate>Verze splash</span></th>
            <th><span v-translate>Operátor</span></th>
            <th><span v-translate>Zařízení</span></th>

            <th class="no_padding edit" />
          </tr>

          </thead>

          <tbody>
          <device-detail-boot-config-row
              v-for="config in availableConfigs"
              :device="entity"
              :entity="config"
              :key="config.id"
              :ref="'avail-config-row-ref-'+config.id"
              @reload="_initBootConfig"
          ></device-detail-boot-config-row>

          <tr v-if="availableConfigs.length === 0">
            <td colspan="9">{{ $gettext('Nebyly nalezeny žádné dostupné konfigurace.') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import localTable from "../../../mixins/local-table";
import DeviceDetailBootConfigRow from "./DeviceBootConfigRow";
import ApiService from "../../../../service/ApiService";
import { $_getApiHost } from "../../../mixins/global/env";
import Vue from "vue";

export default {
  name: "DeviceDetailBootConfigs",
  components: { DeviceDetailBootConfigRow },
  props: {
    entity: Object,
    isEditable: Boolean
  },
  mixins: [localTable],
  created(DeviceBootConfigService) {
    this.entityService = DeviceBootConfigService

    this._initBootConfig()
  },
  data() {
    return {
      assignedConfigs: [],
      availableConfigs: [],
      isLoaded: false,
      template: '',
    }
  },
  methods: {
    _initBootConfig() {
      this.setLoadingMessage();
      this.isLoaded = false;
      this.bootConfigs = [];

      this.entityService.getEntities()
          .then((response) => {
            this.emptyMessage();
            this.assignedConfigs = response.device_boot_configs.filter(config => config.id_device === this.entity.id)
            this.availableConfigs = response.device_boot_configs.filter(config => config.id_device !== this.entity.id)
          })
    },
    _createNewBootConfig() {
      this.$router.push({
        name: 'deviceBootConfigNew',
        params: {
          idDevice: this.entity.id,
          deviceName: this.entity.name,
        }
      });
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/DeviceBootConfigs.vue